import React from 'react';
import { connect } from 'react-redux'
import Security from '../../../security';
import { Redirect } from 'react-router-dom'
import routes from '../../navigation/Routes';
import { debug } from 'util';
import { UserProfileActions, ContextualHelpActions, SchoolInformationActions, SystemConfigActions } from '../../../store/index';
import spinner from '../../ui/icons/spinner.gif'
import { SignIn } from '../../../components/functional/authentication';
import SignOutContainer from '../../functional/authentication/signout/SignOutContainer';
import IdleTimer from 'react-idle-timer';
import theme from '../../../assests/theme'
import lodashUtil from 'lodash'
function asProtectedPage(WrappedComponent, properties) {
    class asProtectedPage extends React.Component {
        constructor(props) {
            super(props)
            this.state = {
                timeout: 1000 * 60 * 60 * 1
            }
            this.idleTimer = null
            this.onIdle = this._onIdle.bind(this)
        }

        _onIdle(e) {
            this.props.cognitoUser.signOut();
            window.location.href = '/'
        }
        setupBeforeUnloadListener = () => {
            window.addEventListener("beforeunload", (ev) => {
                localStorage.setItem('browserCloseTime', new Date().getTime())
            });
        };
        componentWillMount() {
            if (this.props.cognitoUser != null && this.props.userInformation == null) {
                this.props.getUserProfileByCognitoId(this.props.cognitoUser.username);
            }
        }
        componentDidMount() {
            if (this.props.systemConfig !== undefined || lodashUtil.isEmpty(this.props.systemConfig)) {
                this.props.getSystemConfig()
            }
            this.setupBeforeUnloadListener()
            if (this.props.contextualHelp !== undefined || lodashUtil.isEmpty(this.props.contextualHelp)) {
                this.props.getContextualHelp()
            }
        }
        render() {
            if (this.props.cognitoUser != null) {
                if (this.props.userInformation != null) {

                    return (
                        <React.Fragment>
                            {localStorage.getItem('rememberMe') !== 'true' ? <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onActive={this.onActive}
                                onIdle={this.onIdle}
                                onAction={this.onAction}
                                debounce={250}
                                timeout={this.state.timeout} /> : null}
                            {React.createElement(WrappedComponent, { ...this.props })}
                        </React.Fragment>
                    )
                }
                else {
                    return (<img src={spinner} alt="none" style={theme.spinnerImgStyle} />)
                }
            }

            else {
                return (
                    <SignIn />
                )
            }

        }
    }
    return connect(mapStateToProps, mapDispatchToProps)(asProtectedPage)
}


const mapDispatchToProps = (dispatch) => {
    return {
        getUserProfileByCognitoId: (cognitoId) => dispatch(UserProfileActions.getUserProfileByCognitoId(cognitoId)),
        getContextualHelp: () => dispatch(ContextualHelpActions.getContextualHelp()),
        setActiveSchool: (school) => dispatch(SchoolInformationActions.setActiveSchool(school)),
        getSystemConfig: () => dispatch(SystemConfigActions.getSystemConfig())
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        //loginState: state.cognito.state,
        cognitoUser: state.cognito.user,
        userInformation: state.userProfile.userInformation,
        contextualHelp: state.contextualHelp.contextualHelp,
        // signOutInProgress: state.signOut.signOutInProgress,
        // signedOut:state.signOut.signedOut,
        //userProfiles: state.profile.userProfiles
        systemConfig: state.systemConfig.systemConfig
    }
}
export default asProtectedPage;